import { Box } from '@mui/material';

import { cx } from '@/styles/muiTheme';

/**
 * The WSC tag: on a stream row scheduled with `wsc: true`, and as the label of
 * the add-stream form's WSC checkbox, so the two read as the same thing.
 */
export function WscBadge() {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flex: 'none',
        height: 16,
        px: '6px',
        borderRadius: '4px',
        border: '1px solid',
        borderColor: '#000',
        bgcolor: '#E5FE00',
        color: '#000',
        fontFamily: cx.fontMono,
        fontSize: 10,
        lineHeight: '14px',
        letterSpacing: '1px',
      }}
    >
      WSC
    </Box>
  );
}
